<template>
  <div v-if="presenters.length > 0">
    <div v-for="(presenter, index) in presenters" :key="index" class="row py-2">
        <div class="col-6 ps-0 d-flex align-items-center">
            <img v-if="presenter.user && presenter.user.profile_image_url != null" :src="presenter.user.profile_image_url" alt="" width="50" class="img img-responsive rounded">
            <i v-else class="fas fa-circle-user fa-3x text-primary"></i>
            <a v-if="presenter.user" class="ps-4 fs-5 fw-bold" style="pointer-events: none;">
              {{ presenter.user.fullname }}<br />
              <span class="small text-muted">{{ presenter.user.email }}</span>
            </a>
            <a v-else class="ps-4 fs-5 fw-bold" style="pointer-events: none;">{{ presenter.text }}<br /></a>
            <div v-if="presenter.user && presenter.user.is_registered" class="badge bg-secondary border border-primary ms-1 mb-2 rounded">
              {{ $t('network.networkForm.registered') }}
            </div>
            <div v-else class="badge bg-secondary border border-primary ms-1 mb-2 rounded">{{ $t('network.networkForm.not-registered') }}</div>
        </div>
        <div class="col-2 d-flex align-items-center justify-content-end">
          <a v-if="(presenter.user && !presenter.user.is_registered) || !presenter.pivot.presenter_id || (presenter.user && presenter.user.is_registered && $auth.auth && $auth.hasRole('super-admin'))" role="button" class="btn text-primary p-2 py-0 rounded-3"
          @click="showEditPresenter(presenter)">
          {{ $t('network.networkForm.editPresenter') }}</a>
        </div>
        <div class="col-2 d-flex align-items-center justify-content-end">
          <a v-if="(presenter.user && !presenter.user.is_registered) || (presenter.user && presenter.user.is_registered && $auth.auth && $auth.hasRole('super-admin'))"
          role="button" class="btn text-primary p-2 py-0 rounded-3" @click="showEditUser(presenter)">
          {{ $t('network.auth.editUser') }}</a>
        </div>
        <div class="col-2 d-flex align-items-center justify-content-end small">
          <a role="button" class="btn text-danger p-2 py-0 rounded-3" @click="removePresenter(presenter)">{{ $t('network.member.remove') }}</a>
        </div>
        <div class="col-12"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    presenters: {
      type: Array,
      default: null,
    },
    network_media_id: {
      type: [String, Number],
      default: null,
    },
  },
  methods: {
    showEditPresenter(user) {
      console.log(user);
      this.$emit('show-presenter-edit-modal', {
        invitationName: user.text,
        presenterForm: user,
        title: this.$t('network.networkForm.editPresenter'),
        showInviteModal: true,
      });
    },
    showEditUser(user) {
      console.log(user);
      this.$emit('show-user-edit-modal', {
        title: this.$t('network.auth.editUser'),
        userForm: user.user,
        invitationName: user.user.fullname,
        showInviteModal: true,
        inInviteMode: false,
        submitText: this.$t('network.auth.editUser'),
      });
    },
    removePresenter(presenter){
      this.$emit('remove-media-presenter',presenter,'PRESENTER');
    }
  },
};
</script>
